import * as types from './types';

export const updatePatientTrigger = (patientId, by) => {
  return {
    type: types.UPDATE_PATIENT_TRIGGER,
    payload: { patientId, by },
  };
};
// used only by legacy patient-file page
export const updateSelectedTab = tab => ({
  type: types.UPDATE_SELECTED_TAB,
  payload: tab,
});



// WEBPACK FOOTER //
// ./src/state/reducers/patient/patientActions.js